"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

var _ButtonBase = _interopRequireDefault(require("@material-ui/core/ButtonBase"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _ModuleBase = _interopRequireDefault(require("../Module/ModuleBase"));

var _ModuleDate = _interopRequireDefault(require("../Module/ModuleDate"));

var _ModuleLabel = _interopRequireDefault(require("../Module/ModuleLabel"));

var _InboxAttachment = _interopRequireDefault(require("./InboxAttachment"));

var _InboxModuleHeader = _interopRequireDefault(require("./InboxModuleHeader"));

var _getInboxModule2 = _interopRequireDefault(require("./utils/getInboxModule"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    display: "block",
    width: "100%",
    minHeight: theme.spacing(7),
    position: "relative",
    paddingTop: theme.spacing(2.5),
    paddingBottom: theme.spacing(2.5),
    paddingLeft: theme.spacing(8),
    paddingRight: theme.spacing(1.5),
    "& + $root": {
      borderTop: "1px solid",
      borderColor: "#f2f2f2"
    },
    "&:hover": {
      backgroundColor: "#f2f2f2",
      cursor: "pointer",
      "& $subject": {
        textDecoration: "underline"
      }
    }
  },
  footer: {
    marginTop: theme.spacing(1.5),
    //        marginBottom: theme.spacing(2.5),
    paddingLeft: theme.spacing(22)
  },
  content: {
    display: "flex",
    alignItems: "center",
    width: "100%"
  },
  header: {
    minWidth: theme.spacing(22),
    maxWidth: theme.spacing(22),
    overflow: "hidden",
    display: "flex",
    alignItems: "center"
  },
  body: {
    display: "inline-block",
    maxWidth: "100%",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1)
  },
  subject: {
    display: "inline",
    fontFamily: "Akkurat, sans-serif",
    fontWeight: "bold"
  },
  excerpt: {
    display: "inline",
    fontFamily: "Akkurat, sans-serif",
    marginLeft: theme.spacing(.5),
    opacity: ".85"
  },
  datetime: {
    fontFamily: "Akkurat, sans-serif",
    fontSize: "14px",
    whiteSpace: "noWrap",
    opacity: ".75"
  }
}));

const InboxAuthor = ({
  unread,
  shortName,
  name,
  size
}) => {
  const classes = useStyles();

  if (size === "small") {
    return _react.default.createElement("b", {
      className: classes.name,
      "data-unread": unread
    }, shortName);
  }

  return _react.default.createElement("b", {
    className: classes.name,
    "data-unread": unread
  }, name);
};

const InboxAuthors = ({
  authors = []
}) => {
  const classes = useStyles();

  if (!authors.length) {
    return false;
  }

  if (authors.length > 2) {
    return _react.default.createElement(_Typography.default, {
      noWrap: true,
      className: classes.authors
    }, _react.default.createElement(InboxAuthor, _extends({}, authors[0], {
      size: "small"
    })), "...", _react.default.createElement(InboxAuthor, _extends({}, authors[authors.length - 1], {
      size: "small"
    })));
  }

  if (authors.length === 2) {
    return _react.default.createElement(_Typography.default, {
      noWrap: true,
      className: classes.authors
    }, _react.default.createElement(InboxAuthor, _extends({}, authors[0], {
      size: "small"
    })), ",", _react.default.createElement(InboxAuthor, _extends({}, authors[authors.length - 1], {
      size: "small"
    })));
  }

  return _react.default.createElement(_Typography.default, {
    noWrap: true,
    className: classes.authors
  }, _react.default.createElement(InboxAuthor, authors[0]));
};

const InboxModule = (_ref) => {
  let onSelect = _ref.onSelect,
      props = _objectWithoutPropertiesLoose(_ref, ["onSelect"]);

  const _getInboxModule = (0, _getInboxModule2.default)(props),
        datetime = _getInboxModule.datetime,
        subject = _getInboxModule.subject,
        message = _getInboxModule.message,
        attachments = _getInboxModule.attachments,
        label = _getInboxModule.label,
        labelColor = _getInboxModule.labelColor;

  const classes = useStyles();

  const handleSelect = (event, item) => {
    event.stopPropagation();
    onSelect && onSelect(item);
  };

  return _react.default.createElement(_ModuleBase.default, {
    className: classes.root,
    onClick: e => handleSelect(e, props)
  }, _react.default.createElement("div", {
    className: classes.content
  }, _react.default.createElement(_InboxModuleHeader.default, _extends({}, props, {
    className: classes.header
  })), _react.default.createElement(_ModuleLabel.default, {
    label: label,
    color: labelColor
  }), _react.default.createElement(_Typography.default, {
    noWrap: true,
    className: classes.body
  }, _react.default.createElement("b", {
    className: classes.subject
  }, subject), _react.default.createElement("i", {
    className: classes.excerpt
  }, message)), _react.default.createElement(_ModuleDate.default, {
    className: classes.datetime,
    datetime: datetime
  })), attachments && _react.default.createElement("footer", {
    className: classes.footer
  }, attachments.map((attachment, index) => {
    return _react.default.createElement(_InboxAttachment.default, _extends({}, attachment, {
      size: "small",
      onClick: e => handleSelect(e, attachment),
      key: index
    }));
  })));
};

var _default = InboxModule;
exports.default = _default;
module.exports = exports.default;